import { SelectOption } from '@globaleris/ui.library'
import { CountryModel, MunicipalityModel, PostalCode, ProvinceModel } from '../../model/addresses'
import { SearchSelectOption } from '../../../../model/searchSelectOption'

export const postalCodeListMapper = (items: PostalCode[]): SearchSelectOption[] => {
  return items ? items.map(postalCodeItemMapper) : []
}

export const postalCodeItemMapper = (item: PostalCode): SearchSelectOption => {
  return (
    item && {
      value: item.id,
      label: `${item.postalCode} - ${item.municipality?.description}`,
      textValue: item.postalCode
    }
  )
}

export const municipalityListMapper = (items: MunicipalityModel[]): SelectOption[] => {
  return items ? items.map(municipalityItemMapper) : []
}

export const municipalityItemMapper = (item: MunicipalityModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}

export const provinceListMapper = (items: ProvinceModel[]): SelectOption[] => {
  return items ? items.map(provinceItemMapper) : []
}

export const provinceItemMapper = (item: ProvinceModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}

export const countryListMapper = (items: CountryModel[]): SelectOption[] => {
  return items ? items.map(countryItemMapper) : []
}

export const countryItemMapper = (item: CountryModel): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.description
    }
  )
}
